import { render, staticRenderFns } from "./StyleEditorBorder.vue?vue&type=template&id=9a6c5738"
import script from "./StyleEditorBorder.vue?vue&type=script&lang=ts"
export * from "./StyleEditorBorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports